import { useRef } from 'react';
import { ClickAwayListener, Grow, MenuList, Paper, Popper } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useSlate } from 'slate-react';

import { IconMoreHorizontal } from 'src/assets/icons/IconMoreHorizontal';
import { usePopoverAnchor } from 'src/lib/hooks';
import { SLATE_EDITOR_ACTIONS } from 'src/lib/slate';

import { isEditorActionActive, isEditorActionDisabled } from '../../../../utils';
import { EditorActionMenuItem } from '../../../EditorActionMenuItem';
import { ToolbarButton } from '../../../ToolbarButton';

import { useStyles } from './useStyles';

export const ToolbarShowMoreActions = ({ className, editorActions, onAction, disabled }) => {
  const styles = useStyles();
  const editor = useSlate();

  const ref = useRef();
  const [menuAnchor, openMenu, closeMenu] = usePopoverAnchor();
  const handleClick = (event) => {
    event.preventDefault(); // prevent from editor losing focus
    openMenu(event.currentTarget);
  };

  return (
    <div className={cx(styles.root, className)}>
      <ToolbarButton
        className={styles.button}
        ref={ref}
        onMouseDown={handleClick}
        tooltip={menuAnchor ? '' : 'More'}
        selected={Boolean(menuAnchor)}
        disabled={disabled}
      >
        <IconMoreHorizontal />
      </ToolbarButton>

      <Popper
        className={styles.popper}
        anchorEl={menuAnchor}
        open={!!menuAnchor}
        role={undefined}
        placement="bottom-start"
        transition
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'left top',
            }}
          >
            <Paper className={styles.paper}>
              <ClickAwayListener
                onClickAway={closeMenu}
                mouseEvent="onMouseDown"
              >
                <MenuList className={styles.menuList}>
                  {editorActions.map((action) => (
                    <EditorActionMenuItem
                      key={action}
                      action={action}
                      onAction={onAction}
                      active={isEditorActionActive(editor, action)}
                      disabled={disabled || isEditorActionDisabled(editor, action)}
                    />
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

ToolbarShowMoreActions.propTypes = {
  className: PropTypes.string,
  editorActions: PropTypes.arrayOf(PropTypes.oneOf(SLATE_EDITOR_ACTIONS)).isRequired,
  onAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
ToolbarShowMoreActions.defaultProps = {
  className: null,
  disabled: false,
};
